/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("RetailerLimitController", [
            "$scope", "$http", "$sessionStorage", "$oidc",
            function ($scope, $http, $sessionStorage, oidc) {
                $scope.$storage = $sessionStorage;

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (oldValue.Id !== newValue.Id && newValue.Id > 0) {
                        $scope.browse();
                    }
                });

                $scope.list = [];
                $scope.limitType = "1";

                $scope.browse = function () {
                    return $http.get("/api/limits", {
                        params: {
                            retailerId: $scope.$storage.retailer.Id,
                            limitType: $scope.limitType
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    }).then(function (response) {
                        $scope.list = response.data;
                    });
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.retailerLimit.orderName === orderName) {
                        $scope.$storage.retailerLimit.orderDesc = !$scope.$storage.retailerLimit.orderDesc;
                    } else {
                        $scope.$storage.retailerLimit.orderName = orderName;
                        $scope.$storage.retailerLimit.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.retailerLimit.orderName === orderName) {
                        if ($scope.$storage.retailerLimit.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                $scope.onLimitTypeChange = function () {
                    if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                        $scope.browse();
                    }
                };

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.browse();
                }
            }
        ]);

})();
